import Allow from 'components/Allow';
import Title from 'components/Title';
import { enumRules } from 'enum/enumRules';
import { IClient } from 'interfaces/IClient';
import { ICompany } from 'interfaces/ICompany';
import { ICurrency } from 'interfaces/ICurrency';
import { IProductPrice, IProductPriceUpdate } from 'interfaces/IProduct';
import { IProductPriceHistory } from 'interfaces/IProductPriceHistory';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useClientService } from 'services/clientService';
import { useCompanyService } from 'services/companyService';
import { useCurrencyService } from 'services/currencyService';
import { useProductPriceService } from 'services/productPriceService';
import { useProductPriceHistoryService } from 'services/productPriceHistoryService';
import { log } from 'console';
import ChoiceComponent from './Components/ChoiceComponent';
import FilterTextPriceList from './Components/FilterTextPriceList';
import TablePriceListClient from './Components/TablePriceListClient';
import TablePriceHistoryListClient from './Components/TablePriceHistoryListClient';
import TablePriceListCompany from './Components/TablePriceListCompany';
import TablePriceHistoryListCompany from './Components/TablePriceHistoryListCompany';
import { Container } from './styles';

export const ProductPricelist: React.FC = () => {
  const { companyService } = useCompanyService();
  const { clientService } = useClientService();
  const { productPriceService } = useProductPriceService();
  const { productPriceHistoryService } = useProductPriceHistoryService();
  const { currencyService } = useCurrencyService();

  const [companies, setCompanies] = useState<ICompany[]>([] as ICompany[]);
  const [updateHistory, setUpdateHistory] = useState<boolean>(true);
  const [show, setShow] = useState<boolean>(false);
  const [currencies, setCurrencies] = useState<ICurrency[]>([] as ICurrency[]);
  const [companyClients, setCompanyClients] = useState<IClient[]>(
    [] as IClient[]
  );
  const [productPriceList, setProductPriceList] = useState<
    IProductPrice[] | null
  >(null);
  const [productPriceHistoryList, setProductPriceHistoryList] = useState<
    IProductPriceHistory[] | null
  >(null);
  const [copyProductPriceList, setCopyProductPriceList] = useState<
    IProductPrice[] | null
  >(null);
  const [copyProductPriceHistoryList, setCopyProductPriceHistoryList] =
    useState<IProductPriceHistory[] | null>(null);
  const [selectedCompany, setSelectedCompany] = useState<number>(1);
  const [selectedClientId, setSelectedClientId] = useState<number>(0);
  const [selectedCurrency, setSelectedCurrency] = useState<ICurrency>(
    {} as ICurrency
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const findCurrencyForEntity = useCallback(
    (
      entityId: number,
      type: 'Clients' | 'Companies',
      currenciesData: ICurrency[]
    ): ICurrency => {
      return (currenciesData.find(c =>
        c[type]?.split(',').some(a => a === entityId.toString())
      ) || currenciesData.find(c => c.CurrencyId === 1)) as ICurrency; // Default to CurrencyId 1
    },
    []
  );

  const getPricesByClient = useCallback(
    async (clientId: number, currencyId: number) => {
      const { ProductPrices } =
        await productPriceService.findProductPriceByClientId(
          clientId,
          currencyId
        );
      setProductPriceList(ProductPrices);
      setCopyProductPriceList(ProductPrices?.filter(x => true) || []);
    },
    [productPriceService]
  );

  const getPricesHistoryByClient = useCallback(
    async (clientId: number, currencyId: number) => {
      // const { ProductPricesHistory } =
      const { ProductPriceHistories } =
        await productPriceHistoryService.findProductPriceHistoryByClientId(
          clientId,
          currencyId
        );
      setProductPriceHistoryList(ProductPriceHistories);
      console.log('Setou histórico?', ProductPriceHistories);
      setCopyProductPriceHistoryList(
        ProductPriceHistories?.filter(x => true) || []
      );
    },
    [productPriceHistoryService]
  );

  const getPricesByCompany = useCallback(
    async (companyId: number, currencyId: number) => {
      const { ProductPrices } =
        await productPriceService.findProductPriceByCompanyId(
          companyId,
          currencyId
        );
      setProductPriceList(ProductPrices);
      setCopyProductPriceList(ProductPrices?.filter(x => true) || []);
    },
    [productPriceService]
  );

  const getPricesHistoryByCompany = useCallback(
    async (companyId: number, currencyId: number) => {
      const { ProductPriceHistories } =
        await productPriceHistoryService.findProductPriceHistoryByCompanyId(
          companyId,
          currencyId
        );
      console.log('Setou histórico de companhia?', ProductPriceHistories);
      setProductPriceHistoryList(ProductPriceHistories);
      setCopyProductPriceHistoryList(
        ProductPriceHistories?.filter(x => true) || []
      );
    },
    [productPriceHistoryService]
  );

  const getClientsByCompany = useCallback(
    async (companyId: number) => {
      try {
        const clientData = await clientService.findClientByCompanyId(companyId);
        setCompanyClients(clientData.Clients);
        setSelectedClientId(0);
      } catch (error) {
        console.error('Erro ao buscar clientes:', error);
      }
    },
    [clientService]
  );

  const handleChangeCurrency = useCallback(
    async (id: number) => {
      const selected = currencies?.find(x => x.CurrencyId === id) as ICurrency;
      setSelectedCurrency(selected);

      if (selectedClientId !== 0) {
        await getPricesByClient(selectedClientId, id);
        await getPricesHistoryByClient(selectedClientId, id);
      } else {
        await getPricesByCompany(selectedCompany, id);
        await getPricesHistoryByCompany(selectedCompany, id);
      }
    },
    [
      currencies,
      getPricesByClient,
      getPricesHistoryByClient,
      getPricesByCompany,
      getPricesHistoryByCompany,
      selectedClientId,
      selectedCompany
    ]
  );

  const handleChangeCompany = useCallback(
    async (id: number) => {
      setSelectedCompany(id);
      await getClientsByCompany(id);

      const currencyFound = findCurrencyForEntity(id, 'Companies', currencies);
      setSelectedCurrency(currencyFound);
      setCurrencies(prevCurrencies =>
        prevCurrencies.map(currency => ({
          ...currency,
          Disabled: false
        }))
      );
      await getPricesByCompany(id, currencyFound.CurrencyId);
      await getPricesHistoryByCompany(id, currencyFound.CurrencyId);
      setSelectedClientId(0);

      console.log('Selecionando companhia:', id);
      console.log('Moedas disponíveis:', currencies);
      console.log('Moeda encontrada:', currencyFound);
    },
    [
      findCurrencyForEntity,
      getClientsByCompany,
      getPricesByCompany,
      getPricesHistoryByCompany,
      currencies
    ]
  );

  const handleChangeClient = useCallback(
    async (clientId: number) => {
      setSelectedClientId(clientId);

      const currencyFound = findCurrencyForEntity(
        clientId,
        'Clients',
        currencies
      );
      setSelectedCurrency(currencyFound);

      if (clientId === 0) {
        await handleChangeCompany(selectedCompany);
        // await getPricesByCompany(selectedCompany, currencyFound.CurrencyId);
        // await getPricesHistoryByCompany(
        //   selectedCompany,
        //   currencyFound.CurrencyId
        // );
      } else {
        await getPricesByClient(clientId, currencyFound.CurrencyId);
        await getPricesHistoryByClient(clientId, currencyFound.CurrencyId);
      }

      if (clientId !== 0) {
        setCurrencies(prevCurrencies => {
          const currencyId: ICurrency =
            prevCurrencies.find(c =>
              c.Clients.split(',').some(x => x === clientId.toString())
            ) ?? (prevCurrencies.find(c => c.CurrencyId === 1) as ICurrency);

          const newCurrencies = prevCurrencies.map(
            currency =>
              ({
                ...currency,
                Disabled: !(currency.CurrencyId === currencyId?.CurrencyId)
              } as ICurrency)
          );
          return newCurrencies;
        });
      }
    },
    [
      findCurrencyForEntity,
      currencies,
      handleChangeCompany,
      // getPricesByCompany,
      // getPricesHistoryByCompany,
      selectedCompany,
      getPricesByClient,
      getPricesHistoryByClient
    ]
  );

  const getData = useCallback(async () => {
    try {
      setIsLoading(true);
      const companyData = await companyService.getAll();
      const sortedCompanies = companyData.Companies.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      setCompanies(sortedCompanies);

      await getClientsByCompany(1);

      const { Currencies } = await currencyService.getAll();
      setCurrencies(Currencies);

      const initialCurrency = findCurrencyForEntity(1, 'Companies', Currencies);
      setSelectedCurrency(initialCurrency);

      await getPricesByCompany(1, initialCurrency.CurrencyId);
      await getPricesHistoryByCompany(1, initialCurrency.CurrencyId);
    } catch (error) {
      console.error('Erro ao buscar dados em getData:', error);
    } finally {
      setIsLoading(false);
    }
  }, [
    companyService,
    getClientsByCompany,
    currencyService,
    findCurrencyForEntity,
    getPricesByCompany,
    getPricesHistoryByCompany
  ]);

  const handleConfirm = useCallback(async () => {
    try {
      setIsLoading(true);
      const updates: IProductPriceUpdate[] =
        productPriceList?.map(item => ({
          CompanyId: item.CompanyId,
          CostCompany: item.CostCompany,
          PriceCompany: item.PriceCompany,
          ProductId: item.ProductId,
          PriceClient: item.PriceClient,
          CostClient: item.CostClient,
          ClientId: item.ClientId,
          ReplacePrice: updateHistory,
          CurrencyId: selectedCurrency.CurrencyId
        })) || [];

      await productPriceService.updateProductPrice(updates);

      setProductPriceList(
        prev =>
          prev?.map(product => {
            const updatedProduct = updates.find(
              updated => updated.ProductId === product.ProductId
            ) as IProductPriceUpdate;

            return updatedProduct
              ? ({
                  ...product,
                  ...updatedProduct,
                  CompanyId: updatedProduct.CompanyId ?? product.CompanyId, // Garante que CompanyId nunca será null
                  ClientId: updatedProduct.ClientId ?? product.ClientId // Ajuste para evitar erro de null
                } as IProductPrice)
              : product;
          }) || []
      );

      setCopyProductPriceList(productPriceList?.filter(x => true) || []);
    } catch (error) {
      console.error('Erro ao salvar os dados:', error);
    } finally {
      setIsLoading(false);
    }
  }, [productPriceList, updateHistory, selectedCurrency, productPriceService]);

  const handleSubmit = useCallback(() => {
    setShow(true);
  }, [setShow]);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <Container>
      <ChoiceComponent
        show={show}
        setShow={setShow}
        callBackConfirm={handleConfirm}
        choice={updateHistory}
        setChoice={setUpdateHistory}
      />
      <Title>Preços de Produtos</Title>
      {/* SELECTS ESTAO AQUI */}
      <Row>
        <Form.Group as={Col}>
          <Form.Label>Companhia</Form.Label>
          <Form.Select
            id="select-company"
            name="select-company"
            required
            value={selectedCompany}
            onChange={a => handleChangeCompany(Number(a.target.value))}
          >
            {companies.map(a => (
              <option key={a.Id} value={a.Id}>
                {a.Name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>Cliente</Form.Label>
          <Form.Select
            id="select-client"
            name="select-client"
            onChange={a => handleChangeClient(Number(a.target.value))}
            value={selectedClientId}
          >
            <option value={0} label="Selecione" />
            {companyClients.map(client => (
              <option key={client.Id} value={client.Id}>
                {client.Name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>Moeda</Form.Label>
          <Form.Select
            id="select-currency"
            name="select-currency"
            onChange={a => handleChangeCurrency(Number(a.target.value))}
            value={selectedCurrency.CurrencyId}
          >
            {currencies.map(currency => {
              return (
                <option
                  key={currency.CurrencyId}
                  value={currency.CurrencyId}
                  disabled={currency.Disabled}
                >
                  {currency.Description}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
      </Row>
      <br />
      <FilterTextPriceList
        placeholderInput="Id, Nome, Tipo..."
        nameFieldToFilter="ProductId,ProductName,ProductInternalName,ProductType"
        copyData={copyProductPriceList}
        setDataToFilter={setProductPriceList}
      />
      {selectedCompany > 0 && selectedClientId === 0 && (
        <TablePriceListCompany
          list={productPriceList}
          setProductPriceList={setProductPriceList}
          selectedCurrency={selectedCurrency}
        />
      )}
      {selectedCompany > 0 && selectedClientId > 0 && (
        <TablePriceListClient
          list={productPriceList}
          setProductPriceList={setProductPriceList}
          selectedCurrency={selectedCurrency}
        />
      )}
      <br />
      <Row>
        <Allow ruleId={enumRules.ProductPrice.CanWriteProductPrice}>
          <Col>
            <Button
              id="restore-btn"
              onClick={() => getData()}
              disabled={isLoading}
            >
              {isLoading ? 'Carregando...' : 'Restaurar'}
            </Button>{' '}
            <Button onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? 'Salvando...' : 'Salvar'}
            </Button>
          </Col>
        </Allow>
      </Row>
      <br />
      <br />
      {selectedCompany > 0 && selectedClientId === 0 && (
        <TablePriceHistoryListCompany
          list={productPriceHistoryList}
          setProductPriceHistoryList={setProductPriceHistoryList}
          selectedCurrency={selectedCurrency}
        />
      )}
      {selectedCompany > 0 && selectedClientId > 0 && (
        <TablePriceHistoryListClient
          list={productPriceHistoryList}
          setProductPriceHistoryList={setProductPriceHistoryList}
          selectedCurrency={selectedCurrency}
        />
      )}
    </Container>
  );
};
